export enum ErrorCodes {
  EmailAlreadyAssociatedToParent = 'request.resource.conflict.alreadyAssociatedToParent',
  BadImplementation = 'internal.bad_implementation',
}
